import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import awsLogo from 'assets/images/aws.svg';
import solidLogo from 'assets/images/logo_solid-verified-files.svg';
import * as React from 'react';

interface IProps {
  absolute?: boolean;
}

const useStyles = makeStyles((theme) => ({
  solidLogo: {
    display: 'flex',
    alignItems: 'center',
    position: ({ absolute }: IProps) => absolute ? 'absolute' : 'unset',
    bottom: 0,
    width: '100%',
    gap: theme.spacing(1),
    justifyContent: ({ absolute }: IProps) => absolute ? 'flex-start' : 'center'
  }
}));

const Logos = (props: IProps) => {
  const classes = useStyles(props);

  return (
    <div className={classes.solidLogo}>
      <Link target='blank' href={'http://solidfiles.com.br/'}>
        <img src={solidLogo} alt='logo' width='78' />
      </Link>
      <Link target='blank' href={'https://aws.amazon.com/'}>
        <img src={awsLogo} alt='logo aws' width='29' />
      </Link>
    </div>
  );
};

export default Logos;